<script setup>
import { MASKS } from '@base/constants/mask';
import { computed, ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { required, cellPhone } from '@base/validators/composition';

const emit = defineEmits(['close', 'send-whatsapp']);

defineProps({
  showModal: {
    type: Boolean,
    default: false,
  },
});

const rules = {
  whatsapp: { required, cellPhone },
};

const whatsapp = ref('');
const loading = ref(false);
const v$ = useVuelidate(rules, { whatsapp }, { $autoDirty: true });

const buttonIsDisabled = computed(() => v$.value.$invalid);

const getCustomError = (field) => v$.value[field]?.$errors[0]?.$message;

const handleOpenModal = () => {
  whatsapp.value = '';
  v$.value.$reset();
  loading.value = false;
};

const handleSendWhatsapp = () => {
  loading.value = true;
  emit('send-whatsapp', whatsapp.value);
};
</script>

<template>
  <XModal
    :is-open="showModal"
    data-testid="whatsappSendModal"
    @close="$emit('close')"
    @opened="handleOpenModal"
  >
    <template #header>
      {{ $t('flowModule.whatsappSendLink.title') }}
    </template>
    <template #default>
      <p>
        {{ $t('flowModule.whatsappSendLink.description') }}
      </p>
      <XTextInput
        v-model="whatsapp"
        v-mask="MASKS.phone"
        :label="$t('flowModule.whatsappSendLink.inputLabel')"
        placeholder="(__) _____-____"
        :validations="v$.whatsapp"
        :message="getCustomError('whatsapp')"
        data-testid="phoneNumberInput"
      />
    </template>
    <template #actions>
      <XButton
        design="outlined"
        data-testid="actionCloseButton"
        @click="$emit('close')"
      >
        {{ $t('general.action.close') }}
      </XButton>
      <XButton
        :disabled="buttonIsDisabled"
        data-testid="sendWhatsappButton"
        :loading="loading"
        @click="handleSendWhatsapp"
      >
        {{ $t('flowModule.whatsappSendLink.button') }}
      </XButton>
    </template>
  </XModal>
</template>
